var _require = require('./calculateCart.js'),
  restoreCalc = _require.restoreCalc;
var getExcludedDepartments = function getExcludedDepartments(basket) {
  if (!(basket !== null && basket !== void 0 && basket.priceTaxFeeAdjusters) || !basket.priceTaxFeeAdjusters.length) {
    return [];
  }
  var ptfs = basket.priceTaxFeeAdjusters;
  var feebusterPTF = ptfs.find(function (ptf) {
    return ptf.name === 'feebuster';
  });
  return feebusterPTF ? feebusterPTF.supplementalData.excludedDepts : [];
};
var getFeebusterConfig = function getFeebusterConfig(purchases) {
  for (var i = 0; i < purchases.length; i++) {
    var purchase = purchases[i];
    if (purchase.priceTaxFeeAdjustments) {
      for (var j = 0; j < purchase.priceTaxFeeAdjustments.length; j++) {
        var ptf = purchase.priceTaxFeeAdjustments[j];
        if (ptf.name === 'feebuster') {
          var _ptf$extra;
          return (_ptf$extra = ptf.extra) === null || _ptf$extra === void 0 ? void 0 : _ptf$extra.config;
        }
      }
    }
  }
  return null;
};
var unpackBasket = function unpackBasket(basket) {
  var excludedDepts = getExcludedDepartments(basket);
  var feebusterConfig = getFeebusterConfig(basket.purchases);
  var gpi = {
    fee_buster_config: {
      enabled: false,
      fraction: null,
      manualinclusive: false
    },
    price_increase: {
      enabled: false,
      excludedDepts: []
    }
  };
  var gpiConfig = feebusterConfig ? {
    fee_buster_config: {
      enabled: feebusterConfig.enabled || gpi.fee_buster_config.enabled,
      fraction: feebusterConfig.fraction || gpi.fee_buster_config.fraction,
      manualinclusive: feebusterConfig.manualinclusive || gpi.fee_buster_config.manualinclusive
    },
    price_increase: {
      enabled: feebusterConfig.priceIncrease || gpi.price_increase.enabled,
      excludedDepts: excludedDepts
    }
  } : gpi;
  return restoreCalc(basket, gpiConfig);
};
module.exports = unpackBasket;